import { createHashHistory, createBrowserHistory } from 'history';

const history =
  process.env.NODE_ENV !== 'production' ? createHashHistory() : createBrowserHistory();

export default history;
